export enum NotificationAction {
  ADD_CARD = 'PaymentMethodRequired',
  EDIT_CARD = 'PaymentMethodExpired',
  MIGRATION_TYPE = 'MigratedUserRequiresUpgrade',
  VIEW_CARD = 'PaymentMethodExpiringSoon',
  VIEW_SUBSCRIPTIONS = 'ViewSubscriptions',
}
